import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MailWarning, RefreshCw, Loader2, LogOut } from "lucide-react";
import Btn from "./Btn";
import api, { apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyGate() {
  const { user, refresh, logout } = useAuth();
  const [busy, setBusy] = useState(false);
  const [checking, setChecking] = useState(false);

  // Auto-poll every 15s so verification is detected without manual refresh
  useEffect(() => {
    const id = setInterval(() => { refresh?.(); }, 15000);
    return () => clearInterval(id);
  }, [refresh]);

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Tautan verifikasi baru sudah dikirim. Cek inbox/spam emailmu ya!");
    } catch (err) { toast.error(apiErr(err)); } finally { setBusy(false); }
  };

  const check = async () => {
    setChecking(true);
    try {
      await refresh?.();
      toast.info("Jika kamu sudah klik tautan verifikasi, halaman akan terbuka otomatis.");
    } finally { setChecking(false); }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-4 py-10" data-testid="verify-gate">
      <div className="w-full max-w-md card-chunky p-8 text-center animate-pop">
        <div className="w-16 h-16 rounded-2xl bg-su-energy/20 grid place-items-center mx-auto mb-5">
          <MailWarning className="w-8 h-8 text-su-energy" />
        </div>
        <h1 className="font-heading font-black text-2xl text-su-text mb-2">Verifikasi Email Dulu</h1>
        <p className="text-su-muted font-medium text-sm mb-1">
          Kami sudah mengirim tautan verifikasi ke:
        </p>
        <p className="font-heading font-extrabold text-su-primary mb-4 break-all" data-testid="verify-gate-email">{user?.email}</p>
        <p className="text-su-muted font-medium text-sm mb-6">
          Klik tautan di email tersebut untuk membuka semua fitur (tryout, arena, guild, modul, dan lainnya).
          Cek juga folder <b className="text-su-text">spam/promosi</b> ya.
        </p>
        <div className="space-y-3">
          <Btn className="w-full" onClick={check} disabled={checking} data-testid="verify-gate-check">
            {checking ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
            Saya sudah verifikasi — Muat ulang
          </Btn>
          <Btn variant="secondary" className="w-full" onClick={resend} disabled={busy} data-testid="verify-gate-resend">
            {busy ? "Mengirim..." : "Kirim ulang email verifikasi"}
          </Btn>
          <button onClick={logout} data-testid="verify-gate-logout"
            className="w-full inline-flex items-center justify-center gap-2 text-sm font-heading font-bold text-su-muted hover:text-su-danger transition-colors pt-1">
            <LogOut className="w-4 h-4" /> Keluar
          </button>
        </div>
      </div>
    </div>
  );
}
